import { useMediaQuery } from 'react-responsive';

const useIsMediumScreen = () => {
  const isMediumScreen = useMediaQuery({ minWidth: 1024, maxWidth: 1440 });
  return isMediumScreen;
};

export default useIsMediumScreen;
